<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Previous company tax exemption"
      text="Update previous company tax exemption"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col cols="12">
              <div class="font-weight-bold">
                Tax Relief
              </div>
              <span>{{ localTaxExemption.tax_exemption.name }}</span>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="localTaxExemption.amount"
                v-money="money"
                label="Amount"
                prefix="RM"
                outlined
              />
            </v-col>
          </v-row>
        </v-container>
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    directives: { money: VMoney },
    props: {
      taxExemption: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        loading: false,
        localTaxExemption: null,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.localTaxExemption = { ...this.taxExemption }

        if (this.localTaxExemption.amount) { this.localTaxExemption.amount = (Math.round((this.localTaxExemption.amount / 100) * 100) / 100).toFixed(2) }

        this.loading = false
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.companyEmployeeTaxExemptions().update(this.taxExemption.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
              .catch(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          amount: this.localTaxExemption.amount.toString().replaceAll(',', ''),
        }
      },
    },
  }
</script>
